<section class="dashboard">
  <header class="dashboard-header">
    <div class="header-copy">
      <p class="eyebrow">Overview</p>
      <h1>{{ activeSiteName }} dashboard</h1>
      @if (activeSite) {
        <p class="context-site">Publishing control room for <strong>{{ activeSite.name }}</strong></p>
      }
      <p>
        Track content volume, draft backlog, and publishing access for the site currently in focus.
      </p>
    </div>
  </header>

  <section class="quick-actions" aria-label="Quick actions">
    <div class="quick-actions-copy">
      <p class="eyebrow">Quick actions</p>
      <h2>Start something new</h2>
      <p>Create a fresh landing page or capture a new link without leaving the dashboard.</p>
    </div>
    <div class="quick-actions-links">
      <a routerLink="/landing-pages/new" class="accent">New landing page</a>
      <a routerLink="/links/new" class="accent">New link</a>
    </div>
  </section>

  <section class="summary-strip" aria-label="Summary">
    <a routerLink="/landing-pages" class="summary-card summary-card--primary" aria-label="Open landing pages from drafts">
      <span>Drafts</span>
      <strong>{{ draftCount }}</strong>
      <small>Landing pages still waiting for publication.</small>
    </a>
    <a routerLink="/landing-pages" class="summary-card" aria-label="Open landing pages">
      <span>Landing pages</span>
      <strong>{{ activeSiteLandingPageCount }}</strong>
      <small>{{ scheduledCount }} scheduled for later release.</small>
    </a>
    <a routerLink="/api-keys" class="summary-card" aria-label="Open API keys">
      <span>API keys</span>
      <strong>{{ activeSiteApiKeyCount }}</strong>
      <small>Public integration credentials live for this site.</small>
    </a>
    <a routerLink="/links" class="summary-card" aria-label="Open links">
      <span>Links</span>
      <strong>{{ activeSiteLinkCount }}</strong>
      <small>Referenced links available in the workspace.</small>
    </a>
  </section>

  @if (error) {
    <p class="dashboard-note dashboard-note--error">{{ error }}</p>
  } @else if (loading) {
    <p class="dashboard-note">Refreshing landing page status...</p>
  } @else if (activeSite) {
    <p class="dashboard-note">
      {{ draftCount }} draft{{ draftCount === 1 ? '' : 's' }}, {{ scheduledCount }} scheduled, and
      {{ publishedCount }} published landing page{{ publishedCount === 1 ? '' : 's' }} in the current site.
    </p>
  }
</section>
